import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import MasterBase from "../components/MasterLayout";
import { readonly } from '../modules/formstore';
import { isEmpty, getformid, getcontroller, getsubkey } from '../modules/appLibrary';

export const Item = props => {
    const dispatch = useDispatch();
    const formid = getformid("Item", props.location.search);
    const controller = getcontroller("Item", props.location.search);
    const subkey = getsubkey(props.location.search);
    const search = useLocation().search;

    const actionurl = {
        "insert": "item/Insert",
        "update": "item/Update",
        "delete": "item/Delete",
        "saveas": "item/SaveAs",
        "storageadd": "item/AddStorage",
        "storagerowdel": "item/StorageRowdel",
    }
    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
    ]


    return (
        <div>
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                condition={false}
                navmenu={navmenu}
            />
        </div>
    );
};
